export default "__VITE_ASSET__D$hjth3B__"